import { copyStaticFiles } from './lib/copyStaticFiles';

export { copyStaticFiles }

export default copyStaticFiles;
